import { render, staticRenderFns } from "./batchListProgress.vue?vue&type=template&id=fb9aa6d8"
import script from "./batchListProgress.vue?vue&type=script&lang=js"
export * from "./batchListProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports